import React from "react";
import DirectionBHome from "../components/directionB/DirectionBHome";
import DirectionBNotFound from "../components/directionB/DirectionBNotFound";
import { Routes, Route } from "react-router-dom";
import ScrollTopBehaviour from "../components/ScrollTopBehaviour";
import CaseStudyDetail from "../components/portfolio/CaseStudyDetail";

const AllRoutes = () => {
  return (
    <>
      <ScrollTopBehaviour />
      <Routes>
        <Route path="/work/:slug" element={<CaseStudyDetail />} />
        <Route path="/" element={<DirectionBHome />} />
        <Route path="*" element={<DirectionBNotFound />} />
      </Routes>
    </>
  );
};

export default AllRoutes;
